/* jshint esversion: 6 */

import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

class WebsiteWidgetCloseForm extends React.Component {
  render() {
    return (
      <div id="hard-close-confirmation" className={this.props.className}>
        <div id="hard-close-confirmation-content">
          <span id="hard-close-confirmation-text">Are you sure you want to leave this conversation?</span>
          <div id="hard-close-no-button" role="button" tabIndex="0" aria-label="remain in conversation" onClick={this.props.onCancel} onKeyDown={(e) => { if (e.key == " " || e.code == "Space" || e.keyCode == 32) { this.props.onCancel() }} }style={{
            background: "#19BE51",
            color: "#fff",
            display: 'block'
          }}>No, stay in this conversation</div>
          <div id="hard-close-yes-button" role="button" tabIndex="0" aria-label="confirm exit conversation"  onClick={this.props.onConfirm} onKeyDown={(e) => { if (e.key == " " || e.code == "Space" || e.keyCode == 32) { this.props.onConfirm() }} } style={{
            background: "#D22600",
            color: "#fff",
            display: 'block'
          }}>Yes, leave this conversation</div>
        </div>
      </div>
    );
  }
}

WebsiteWidgetCloseForm.propTypes = {
  className: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default WebsiteWidgetCloseForm;
